import { Outlet } from 'react-router'
import { Header } from '@/components/commons/header'

export const PrivateVettingLayout = () => {
	return (
		<div className='grid h-full grid-rows-[auto_1fr] overflow-hidden'>
			<Header />
			<div className='flex h-full flex-col overflow-y-auto'>
				<Outlet />
			</div>
		</div>
	)
}

PrivateVettingLayout.displayName = 'PrivateVettingLayout'
